<template>
  <div>
    <!-- <b-container class="home-container text-left">
      <b-row class="mb-3">
        <b-col md="mb-lg-4">
          <h1 class="mb-lg-2" id="esgTitle">
            ESG – oktatás és vállalkozásfejlesztési szolgáltatások
          </h1>
        </b-col>
      </b-row>
    </b-container> -->
    <b-container>
      <b-row>
        <b-col class="top-header-col" cols="12">
          <img src="../assets/img/ESG_background.jpg" class="background-image" />
          <img src="../assets/img/ESG.svg" class="overlay-image" />
          <div class="overlay-text">
            oktatás és vállalkozásfejlesztési szolgáltatások
          </div>
        </b-col>
      </b-row>
    </b-container>
    <div class="wrapper pb-1 pt-5">
      <b-container>
        <b-row class="mb-3 mb-md-5 mt-3">
          <b-col cols="12" lg="12" class="wrapper-p">
            <p>
              Az ESG olyan fenntarthatósági kérdésekre vonatkozó szempontrendszer, amely egy adott vállalkozásnál a
              környezetre, a társadalomra és az irányításra vonatkozó hatásokat és faktorokat értékeli fenntarthatósági
              szempontból. Az ESG mozaikszó, amely az Environmental (környezeti) – Social (társadalmi) és Governance
              (vállalatirányítási) szavak kezdőbetűiből eredeztethető. A nemzetközi gyakorlatban egy olyan gazdasági
              információrendszert jelöl, amelynek célja, hogy az egyes gazdálkodó szervezetek tevékenysége
              fenntarthatósági szempontok alapján is összehasonlítható és objektíven vizsgálható legyen.
            </p>
            <p>
              A Magyar Gazdaságfejlesztési Ügynökség (MGFÜ) elkötelezett az ESG szempontrendszer alapelvei mellett.
              Célunk, hogy támogassuk a hazai vállalkozásokat az elvárások teljesítésében, illetve az ahhoz szükséges
              módszertanok bevezetésében és alkalmazásában. Hisszük, hogy a fenntarthatóság, a társadalmi
              felelősségvállalás és az átlátható irányítás kulcsfontosságú a versenyképesség és hosszú távon is
              fenntartható működés biztosítása érdekében.
            </p>
            <p>
              ESG alapelvek mentén segítünk a vállalkozásoknak csökkenteni környezeti lábnyomukat, növelni társadalmi
              szerepvállalásukat és javítani irányítási gyakorlataikat. Az ESG tanácsadói képzéseket nyújtó oktatási
              intézmények akkreditációs eljárásának lebonyolításán túl, olyan programokat dolgozunk ki és valósítunk
              meg, amelyek elősegítik, hogy a hazai vállalkozások sikeres ESG alapú stratégiáikkal nyertesek lehessenek
              egy dinamikusan változó jövőben is.
            </p>
          </b-col>
          <!-- <b-col offset="1" cols="3" class="pt-4 justify-content-end d-lg-block d-none">
            <img src="../assets/img/leaf.svg" />
          </b-col> -->
        </b-row>
      </b-container>
    </div>
    <div class="wrapper pb-5">
      <b-container>
        <div class="wrapper pb-5">
          <b-container>
            <b-row class="mb-5">
              <b-col cols="12" md="4">
                <a href="/ESG/Szolgaltatasok">
                  <div class="info-box first-box">
                    <h3 class="sub-title">ESG Kompetencia Központ</h3>
                  </div>
                </a>
              </b-col>
              <b-col cols="12" md="4">
                <a href="/ESG/Akkreditacio">
                  <div class="info-box second-box">
                    <h3 class="sub-title">Oktató intézmények akkreditációja</h3>
                  </div>
                </a>
              </b-col>
              <b-col cols="12" md="4">
                <a href="/ESG/Intezmenyek">
                  <div class="third-box info-box">
                    <h3 class="sub-title">Akkreditált intézmények nyilvántartása</h3>
                  </div>
                </a>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="4">
                <a href="/ESG/Vallalkozasok">
                  <div class="info-box first-box">
                    <h3 class="sub-title">ESG a vállalkozások életében</h3>
                  </div>
                </a>
              </b-col>
              <b-col cols="12" md="4">
                <a href="/ESG/Treningek">
                  <div class="info-box second-box">
                    <h3 class="sub-title">Piaci ESG tréningek</h3>
                  </div>
                </a>
              </b-col>
              <b-col cols="12" md="4">
                <a href="/ESG/Kezikonyvek-utmutatok">
                  <div class="info-box third-box">
                    <h3 class="sub-title">Útmutatók, kézikönyvek, segédletek</h3>
                  </div>
                </a>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <b-row class="efragLogo">
          <img class="m-4 p-2 efragLogo" src="../assets/img/EFRAG_logo.svg" alt="EFRAG logo" />
        </b-row>
        <b-row>
          <ul class="footerList">
            <li>A Magyar Gazdaságfejlesztési Ügynökség</li>
            <li>az Európai Pénzügyi Beszámolási Tanácsadó Csoport (EFRAG)</li>
            <li>kis- és középvállalkozások önkéntes fenntarthatósági jelentéstételi szabványának (VSME)</li>
            <li>kidolgozását támogató szakmai közösség,</li>
            <li>a VSME Community tagja.</li>
          </ul>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ESG',
  mounted() {
    if (window.location.pathname === '/ESG/') {
      window.location.replace('/ESG')
    }
  }
}
</script>

<style scoped>
.efragLogo {
  text-align: center;
  margin: 0 auto;
  justify-content: center;
  width: 26rem;
}
.footerList {
  list-style: none;
  text-align: center !important;
  justify-content: center !important;
  margin: 0 auto;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans',
    'Helvetica Neue', sans-serif;
  color: #727373;
}

.footerList li {
  text-align: center; /* ha külön kell */
  margin-bottom: 10px; /* opcionális elválasztás */
}

.wrapper {
  width: 100%;
  max-width: 1115px;
  margin: 0 auto;
  padding: 0 15px;
}
.wrapper-p {
  max-width: 97%;
  text-align: justify;
  margin-left: 15px;
  font-size: 14px;
}
.btn {
  line-height: 32px;
}
.button {
  background: #00903c;
  font-weight: 700;
  color: #fff;
  width: 100%;
  height: 48px;
  line-height: 32px;
  border-radius: 8px;
}
.img-shadow {
  box-shadow: -38px 35px #d9eee2;
  border-radius: 40px 0px;
}

.info-box {
  height: 20rem;
  background: rgb(66, 184, 113);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.info-box {
  height: 21rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; /* vízszintes középre igazítás */
  color: white;
  padding: 15px;
  border-radius: 1rem;
  background-repeat: no-repeat;
  background-position: center center;
}

.first-box {
  background-image: url('../assets/img/ESG/card-1.svg');
  margin: 0 auto;
}
.second-box {
  background-image: url('../assets/img/ESG/card-2.svg');
  margin: 0 auto;
}
.third-box {
  background-image: url('../assets/img/ESG/card-3.svg');
  margin: 0 auto;
}

.info-box > * {
  position: relative;
  z-index: 1;
}

.sub-title {
  text-align: center;
  font-weight: bold;
  color: white;
  font-size: 1.6rem;
}

.overlay-text {
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 38px;
  font-weight: bold;
  text-align: center;
  padding: 10px 20px;
  border-radius: 10px;
  width: 80%;
}

.background-image {
  max-width: 100%;
}

.overlay-image {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 55%;
  opacity: 0.8;
}

.top-header-col {
  margin-left: -2px;
}

#esgTitle {
  font-size: 47px;
}

@media (max-width: 992px) {
  .wrapper {
    margin-bottom: 2rem;
  }
  .wrapper-2 {
    height: 222px;
  }

  .efragLogo {
    width: 100%;
  }
  .info-box {
    margin-bottom: 20px;
    width: 100%;
    box-sizing: border-box;
  }
  #esgTitle {
    font-size: 35px;
  }
  .row-cols-5 {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .row-cols-5 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

@media (max-width: 1200px) {
  .overlay-text {
    font-size: 34px;
  }
}

@media (max-width: 768px) {
  .overlay-text {
    font-size: 14px;
    width: 100% !important;
  }

  .wrapper-p {
    font-size: 12px;
    margin-left: 0;
  }
}
</style>
